import React from 'react'

import {
  DRIFT_CHAT_OPPORTUNITY_OVERVIEW,
  EXPORT_MESSAGE_BY_STATUS,
  formatExportFileName,
} from 'cube'
import { CubeReportFilterContainer } from 'cube/components/CubeReportFilterContainer'
import CubeReportPageFiltersContext from 'cube/contexts/cubeReportPageFilters.context'

import { Button, ButtonGroup, Flex, styled, useToast } from '@driftt/dds'
import { CubeQueryBuilder, useCubeExport } from '@driftt/dds.reports'

import { FilterChipGroup } from 'components/FilterChipGroup'
import { useOpportunitiesStore } from 'layouts/RevenueReport/Opportunities/Opportunities.context'
import { OpportunitiesContextType } from 'layouts/RevenueReport/Opportunities/Opportunities.types'
import { OpportunitiesBaseQuery } from 'layouts/RevenueReport/RevenueReport.query'
import { ReportPage } from 'types/pages'

const StyledHeaderContainer = styled(Flex, {
  padding: '$3 $2',
})

export const OpportunitiesTableHeader = () => {
  const triggerToast = useToast()

  const {
    store: { startDate, endDate, filters, order },
    setStore,
  } = useOpportunitiesStore()

  const opportunitiesExportQuery = new CubeQueryBuilder({
    query: OpportunitiesBaseQuery,
  })
    .withName(`OpportunitiesExportBase`)
    .withQueryName(`OpportunitiesExportBase`)
    .withOrder([
      [DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_CREATED_AT, 'desc'],
    ])
    .withinDateRange(
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_CREATED_AT,
      startDate,
      endDate
    )
    .withFilters(filters)
    .build()

  const { isInitialLoading: isDownloadingExport, refetch: exportCubeData } =
    useCubeExport({
      query: opportunitiesExportQuery,
      enabled: false,
      exportFileName: formatExportFileName('Opportunities', startDate, endDate),
      onExportSuccess() {
        triggerToast({
          message: EXPORT_MESSAGE_BY_STATUS.SUCCESS,
          variant: 'success',
        })
      },
      onExportError() {
        triggerToast({
          message: EXPORT_MESSAGE_BY_STATUS.ERROR,
          variant: 'error',
        })
      },
    })

  return (
    <StyledHeaderContainer fullWidth direction="column" gap={2}>
      <CubeReportPageFiltersContext.Provider
        value={{
          pageFilters: filters,
          onChangePageFilters: (updatedFilters) => {
            setStore({
              startDate: startDate,
              endDate: endDate,
              filters: updatedFilters,
              order: order,
            })
          },
        }}
      >
        <Flex fullWidth justifyContent="space-between">
          <Flex alignItems="center">
            <CubeReportFilterContainer
              reportType={ReportPage.RevenueOpportunities}
            />
          </Flex>
          <ButtonGroup>
            <Button
              loading={isDownloadingExport}
              onClick={() => exportCubeData()}
            >
              Export as CSV
            </Button>
          </ButtonGroup>
        </Flex>
      </CubeReportPageFiltersContext.Provider>
      <FilterChipGroup<OpportunitiesContextType>
        useStore={useOpportunitiesStore}
      />
    </StyledHeaderContainer>
  )
}
